'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lBreakpoints = exports.lTransformers = exports.lApi = exports.pScopes = exports.lData = exports.lDataScopes = undefined;

var _ramda = require('ramda');

var _config = require('../const/config');

var API = _config.CONFIG_FIELD_NAMES.API,
    SCOPES = _config.CONFIG_FIELD_NAMES.SCOPES,
    DATA = _config.CONFIG_FIELD_NAMES.DATA,
    TRANSFORMERS = _config.CONFIG_FIELD_NAMES.TRANSFORMERS,
    BREAKPOINTS = _config.CONFIG_FIELD_NAMES.BREAKPOINTS;
var lDataScopes = exports.lDataScopes = (0, _ramda.lensPath)([DATA, SCOPES]);
var lData = exports.lData = (0, _ramda.lensProp)(DATA);
var pScopes = exports.pScopes = (0, _ramda.prop)(SCOPES);
var lApi = exports.lApi = (0, _ramda.lensProp)(API);
var lTransformers = exports.lTransformers = (0, _ramda.lensProp)(TRANSFORMERS);
var lBreakpoints = exports.lBreakpoints = (0, _ramda.lensProp)(BREAKPOINTS);


//////////////////
// WEBPACK FOOTER
// ./~/cssapi/lib/utils/config.js
// module id = 177
// module chunks = 168707334958949